import React from "react";
import { ArrowRight } from "lucide-react";
import { HERO_IMG, DIRECTORY } from "@/components/landing/landingData";
import { GreenButton, GhostButton, scrollToId } from "@/components/landing/LandingHeader";
import { LegalLinks, COMPANY } from "@/components/legal/LegalLayout";

export const FinalCta = ({ onFree }) => (
  <section data-testid="lp-final" className="relative overflow-hidden border-t border-white/5 py-24">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,rgba(34,211,238,0.18),transparent_60%)]" />
    <div className="lp-dots pointer-events-none absolute inset-0 opacity-50" />
    <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
      <img src={HERO_IMG} alt="QSI HAT TRICK" loading="lazy" className="mx-auto h-20 w-auto rounded-lg object-contain drop-shadow-[0_0_30px_rgba(34,211,238,0.3)]" />
      <p className="mx-auto mt-5 max-w-xl text-sm text-slate-300 sm:text-base">Free access is open. Hat Trick Premium is coming soon. Get started today and explore the sports analytics available to you.</p>
      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
        <GreenButton data-testid="lp-final-free" onClick={onFree}>Get Hat Trick Free <ArrowRight className="h-4 w-4" /></GreenButton>
        <GhostButton data-testid="lp-final-explore" onClick={() => scrollToId("dashboards")}>Explore All Dashboards</GhostButton>
      </div>
    </div>
  </section>
);

export const LandingFooter = ({ onSignIn, onOpen }) => (
  <footer data-testid="lp-footer" className="border-t border-white/5 bg-black py-12">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 md:grid-cols-[1.2fr_2fr]">
      <div>
        <img src={HERO_IMG} alt="QSI HAT TRICK" loading="lazy" className="h-12 w-auto rounded-md object-contain" />
        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-[#22D3EE]">A QSI Product · hat-trick.cc</p>
        <button data-testid="lp-footer-signin" onClick={onSignIn} className="mt-4 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-white hover:text-[#22D3EE]">Sign In →</button>
      </div>
      <div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
        {DIRECTORY.map((g) => (
          <div key={g.group}>
            <p className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-slate-400">{g.group}</p>
            <ul className="mt-3 space-y-1.5">
              {g.items.map((d) => <li key={d.key}><button data-testid={`lp-footer-${d.key}`} onClick={() => onOpen(d.key, d.name)} className="text-[13px] text-slate-400 transition-colors hover:text-[#22D3EE]">{d.name}</button></li>)}
            </ul>
          </div>
        ))}
      </div>
    </div>
    <div data-testid="lp-disclaimer" className="mx-auto mt-10 max-w-7xl px-4 text-[11px] leading-relaxed text-slate-500 sm:px-6">
      <LegalLinks className="mb-4 flex font-mono text-[11px] uppercase tracking-[0.15em] text-slate-300" />
      <span className="block">© 2026 {COMPANY}. </span>
      Hat Trick provides sports statistics and research for informational and entertainment purposes only. Nothing on this site is a guarantee of any outcome or financial advice. If you choose to bet, you must be of legal age where you live; please gamble responsibly. If gambling is a problem for you or someone you know, call 1-800-GAMBLER.
    </div>
  </footer>
);
